import { css } from '@compiled/react';
import { useIntl } from 'react-intl';

import { ProductKeys } from '@atlassiansox/asc-stargate';

import { LogoV3 } from '@/libraries/wpl/foundations/src/logo-v3';

type ProductHeaderProps = {
	productKey: ProductKeys;
	templateName?: string;
	selectedLabel?: string;
};

const ProductHeader = ({ productKey, templateName, selectedLabel }: ProductHeaderProps) => {
	const intl = useIntl();
	const getBrand = (productKey: ProductKeys) => {
		switch (productKey) {
			case ProductKeys.JIRA_SOFTWARE:
			case ProductKeys.JIRA_CORE:
				return 'jirasoftware';
			case ProductKeys.JIRA_SERVICE_DESK:
				return 'jiraservicemanagement';
			case ProductKeys.CONFLUENCE:
			default:
				return 'confluence';
		}
	};

	const youSelectedLabel = intl.formatMessage({
		id: 'SiteSelectorModal.modalHeader.youSelected',
		defaultMessage: 'You selected',
	});

	return (
		<div>
			<LogoV3 type={'logo'} appearance={'brand'} brand={getBrand(productKey)} height="32px" />
			<div css={subHeadlineStyle}>
				{selectedLabel ?? youSelectedLabel}
				<span css={selectedTemplateStyle}>{templateName}</span>
			</div>
		</div>
	);
};

const subHeadlineStyle = css({
	fontSize: '16px',
});

const selectedTemplateStyle = css({
	fontWeight: 'bold',
	paddingInlineStart: '5px',
});

export default ProductHeader;
